import { useAsyncModal } from '@ipfabric/frontend-shared-assets/utils/react/useAsyncModal';
import { Button } from 'components/Button/Button';
import { FormField } from 'components/FormField/FormField';
import { OverlayModal } from 'components/OverlayModal/OverlayModal';
import { OverlayModalBody } from 'components/OverlayModal/OverlayModalBody';
import { OverlayModalFooter } from 'components/OverlayModal/OverlayModalFooter';
import { OverlayModalHeader } from 'components/OverlayModal/OverlayModalHeader';
import { Select } from 'components/Select/Select';
import type { VendorsSettingsId } from 'components/SnapshotCreation/SnapshotCreationTable';
import { useLocale } from 'containers/App/LocaleContext';
import { useState } from 'react';
import type { FC } from 'react';
import type {
  SnapshotCreationOptionType,
  SourceSelectEvent,
} from './SnapshotCreationDeviceSettings';

type Props = {
  options: SnapshotCreationOptionType[];
  onSourceSelect: (settingsId: VendorsSettingsId) => void;
};

export const SnapshotCreationSelectVendor: FC<Props> = (props) => {
  const selectVendorMsg = useLocale().snapshotCreation.selectVendor;
  const selectVendorDialog = useAsyncModal<SourceSelectEvent | null>();
  const [settingsId, setSettingsId] = useState<string | null>(null);

  return (
    <>
      <Button
        type='button'
        variant='tertiary'
        onClick={() => {
          selectVendorDialog.show();
        }}
      >
        {selectVendorMsg.openDialogButton}
      </Button>
      {selectVendorDialog.render((returnFromModal) => (
        <OverlayModal onClose={() => returnFromModal(null)}>
          <OverlayModalHeader>
            <h4>{selectVendorMsg.header}</h4>
          </OverlayModalHeader>
          <OverlayModalBody>
            <FormField label={selectVendorMsg.vendorApiSelectLabel}>
              <Select
                options={props.options}
                onChange={setSettingsId}
                value={settingsId}
              />
            </FormField>
          </OverlayModalBody>
          <OverlayModalFooter>
            <div className='flex justify-between gap-4'>
              <Button
                variant='secondary'
                type='button'
                onClick={() => returnFromModal(null)}
              >
                {selectVendorMsg.btnClose}
              </Button>
              <Button
                variant='primary'
                onClick={() => {
                  props.onSourceSelect(settingsId!);
                }}
                disabled={settingsId === null}
                type='button'
              >
                {selectVendorMsg.btnConfirm}
              </Button>
            </div>
          </OverlayModalFooter>
        </OverlayModal>
      ))}
    </>
  );
};
